import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-indigo-100 text-indigo-700 dark:bg-blue-900/50 dark:text-indigo-400 shadow hover:bg-blue-200 dark:hover:bg-blue-900/70",
        secondary:
          "border-transparent bg-slate-100 text-slate-600 dark:bg-zinc-800 dark:text-zinc-300 hover:bg-slate-200 dark:hover:bg-slate-600",
        destructive:
          "border-transparent bg-red-100 text-red-700 dark:bg-red-900/50 dark:text-red-400 shadow hover:bg-red-200 dark:hover:bg-red-900/70",
        outline: "text-slate-700 dark:text-zinc-300 border-slate-300 dark:border-zinc-700",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
